export const userTableMapping = {
  columns: [
    { headerName: "Login Id", mappedValue: "loginId" }, //change to loginId
    { headerName: "Name", mappedValue: "name" },
    { headerName: "Mobile", mappedValue: "mobile" },
    { headerName: "Designation", mappedValue: "designation" },
  ],
};
export const notificationSearchParams = ["loginId","mobile","name"];